import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const MarqueeSection = () => {
  const marqueeRef = useRef(null);

  useEffect(() => {
    const marquee = marqueeRef.current;
    
    gsap.to(marquee, {
      xPercent: -50,
      ease: 'none',
      duration: 30,
      repeat: -1
    });

    // Pause on hover
    marquee.addEventListener('mouseenter', () => {
      gsap.to(marquee, { timeScale: 0, duration: 0.3 });
    });
    
    marquee.addEventListener('mouseleave', () => {
      gsap.to(marquee, { timeScale: 1, duration: 0.3 });
    });

    return () => {
      gsap.killTweensOf(marquee);
    };
  }, []);

  const items = [
    'EVALUATE', 'DEVELOP', 'RECRUIT', 'REPRESENT',
    'NEGOTIATE', 'SUCCEED', 'COMPARE', 'COMPETE',
    'CONNECT', 'DISCOVER', 'TRACK', 'MANAGE'
  ];

  return (
    <section className="py-12 bg-[#D3FF62] overflow-hidden">
      <div
        ref={marqueeRef}
        className="flex items-center whitespace-nowrap cursor-default"
      >
        {/* Duplicate items for seamless loop */}
        {[...items, ...items].map((item, index) => (
          <span
            key={index}
            className="flex items-center mx-8"
          >
            <span className="text-[#004534] text-4xl md:text-6xl font-black uppercase tracking-tight">
              {item}
            </span>
            <span className="mx-8 w-3 h-3 rounded-full bg-[#004534]" />
          </span>
        ))}
      </div>
    </section>
  );
};

export default MarqueeSection;
